<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Level Name"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("levelName") }}&nbsp;<span style="color: red">*</span>
                </label>
                <multiselect
                  v-model="form.levelName"
                  :key="form.levelName"
                  :options="[
                    'warning level 1',
                    'warning level 2',
                    'warning level 3',
                  ]"
                  :multiple="false"
                  :class="{'is-invalid' : errors[0]}"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Name"
                rules="required"
              >
                <TextInput
                  v-model="form.name"
                  :label="$t('name')"
                  :required="true"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Document Template"
                rules="required"
              >
                <MultiSelectInput
                  :required="true"
                  v-model="form.documentTemplateId"
                  :options="documentServices.data"
                  :key="form.documentTemplateId"
                  :multiple="false"
                  :textLabel="$t('documentTemplate')"
                  label="name"
                  trackBy="id"
                  moduleName="documentService"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Period Days"
                rules="required"
              >
                <text-input
                  :type="`number`"
                  :required="true"
                  v-model="form.periodDays"
                  :error="errors[0]"
                  :label="$t('periodDays')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-md-6">
              <validation-provider
                #default="{ errors }"
                name="Reminder Fee"
                rules="required"
              >
                <text-input
                  :type="`number`"
                  :required="true"
                  v-model="form.reminderFee"
                  :error="errors[0]"
                  :label="$t('reminderFee')"
                  
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <validation-provider
                #default="{ errors }"
                name="Start Text"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("startText") }}&nbsp;<span style="color: red">*</span>
                </label>
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="form.startText"
                  :class="{'is-invalid' : errors[0]}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <validation-provider
                #default="{ errors }"
                name="End Text"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("endText") }}&nbsp;<span style="color: red">*</span>
                </label>
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="form.endText"
                  :class="{'is-invalid' : errors[0]}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-12">
              <validation-provider
                #default="{ errors }"
                name="Mail Text"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("mailText") }}&nbsp;<span style="color: red">*</span>
                </label>
                <textarea
                  class="form-control"
                  rows="5"
                  v-model="form.mailText"
                  :class="{'is-invalid' : errors[0]}"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-end">
        <b-button
          variant="primary"
          @click="updateReminderLevel"
          class="d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.edit`)"
          :disabled="isFormInvalid"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("updateReminderLevel") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import Multiselect from "vue-multiselect";
import formDirtyMixin from "@/mixins/formDirtyMixin";

export default {
  components: {
    TextInput,
    PageHeader,
    Multiselect,
    ValidationProvider,
    ValidationObserver,
    MultiSelectInput,
  },
  computed: {
    ...mapGetters("documentService", ["documentServices", "count"]),
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("settings"),
          to: "/settings",
        },
        {
          text: this.$t("reminderLevels"),
          to: "/invoice-reminder-levels",
        },
        {
          text: this.$t("edit"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.levelName ||
        !this.form.periodDays ||
        !this.form.reminderFee ||
        !this.form.startText ||
        !this.form.endText ||
        !this.form.mailText
      );
    },
  },
  data() {
    return {
      form: {
        levelName: "",
        periodDays: "",
        reminderFee: "",
        startText: "",
        endText: "",
        mailText: "",
        name: "",
        documentTemplateId: "",
      },
      originalForm: null,
    };
  },
  mixins: [formDirtyMixin],
  async mounted() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("documentService/list", {
        limit_start: 0,
        limit_count: 25,
      });
      await this.$store
        .dispatch("invoiceReminderLevel/show", this.$route.params.id)
        .then(async (res) => {
          var response = res?.data?.data;
          this.form = {
            levelName: response.levelName,
            periodDays: response.periodDays,
            reminderFee: response.reminderFee,
            startText: response.startText,
            endText: response.endText,
            mailText: response.mailText,
            name: response.name,
            documentTemplateId: response.documentTemplateId,
          };

          this.assignDocumentTemplate();
        });
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  methods: {
    async assignDocumentTemplate() {
      try {
        const response = await this.$store.dispatch(
          "documentService/show",
          this.form.documentTemplateId
        );
        this.form.documentTemplateId = response?.data ?? "";
        this.originalForm = JSON.stringify(this.form);
      } catch (e) {}
    },
    async updateReminderLevel() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          try {
            this.$store.commit("showLoader", true);
            await this.$store.dispatch("invoiceReminderLevel/update", {
              id: this.$route.params.id,
              data: {
                ...this.form,
                documentTemplateId: this.form.documentTemplateId?.id ?? "",
              },
            });
            this.isFormDirty = false;
            this.originalForm = JSON.stringify(this.form);
            this.$router.push("/invoice-reminder-levels");
          } catch (e) {
            console.error("api error ___", e);
          } finally {
            this.$store.commit("showLoader", false);
          }
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
